import React from 'react';
import { Comment, Icon, Tooltip } from 'antd';
import moment from 'moment';
import Editor from './Editor';

const CommentItem = ({
  createTime,
  fromName,
  toName,
  isReply,
  content,
  children,
  handleReply,
  uuid,
  onSubmit,
  onChange,
  onMention,
  submitting,
}) => (
  <Comment
    className="comment-item"
    author={
      <a>
        {toName ? (
          <span className="name">
            {`${fromName}`}
            <span className="reply">回复</span>
            {`${toName}`}
          </span>
        ) : (
          <span className="name">{fromName}</span>
        )}
      </a>
    }
    datetime={
      <Tooltip title={moment.unix(createTime / 1000).format('YYYY-MM-DD HH:mm:ss')}>
        <span>{moment.unix(createTime / 1000).fromNow()}</span>
      </Tooltip>
    }
    content={
      <div>
        <p>{content}</p>
        <div className="reply-stat">
          <Icon type="edit" />
          {isReply ? (
            <a onClick={() => handleReply(uuid)}>取消回复</a>
          ) : (
            <a onClick={() => handleReply(uuid)}>回复</a>
          )}
        </div>
        {isReply ? (
          <div className="reply-form">
            <Editor
              placeholder={`回复${fromName}`}
              onSubmit={onSubmit}
              onChange={onChange}
              onMention={onMention}
              submitting={submitting}
            />
          </div>
        ) : null}
      </div>
    }
  >
    {children}
  </Comment>
);
export default CommentItem;



// WEBPACK FOOTER //
// ./src/components/comm/comment/CommentItem.js